// QuickDonate.jsx — patched with receipt persistence + navigation state
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  useDonationState,
  useDonationDispatch,
} from "../../context/DonationContext";
import { DONATION_OPTIONS } from "../../data/donationOptions";
import FoorForLife from "./assests/foodForLife.webp";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import style from "./Q.module.css";
import axios from "axios";
import { DashboardContext } from "../../context/DashboardContext";
import { AuthContext } from "../../context/AuthContext";
import moment from "moment";
const API =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : " https://www.iskconvijayawada.org/api ");
if (process.env.NODE_ENV === "production" && !process.env.REACT_APP_API_URL) {
  console.error(
    "REACT_APP_API_URL is not defined. Set REACT_APP_API_URL to your backend URL at build time.",
  );
}

const GOOGLE_SHEET_URL =
  "https://script.google.com/macros/s/AKfycbzrkFAKB06oncKz_K-NuGI9IfEfftYdr0s9VDSn_tnilCq-r3Lni2WcSQy4SzidUdhW/exec";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

async function loadRazorpaySDK() {
  if (window.Razorpay) return window.Razorpay;
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => {
      if (window.Razorpay) resolve(window.Razorpay);
      else reject(new Error("Razorpay loaded but window.Razorpay missing"));
    };
    s.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
    document.body.appendChild(s);
  });
}

export default function QuickDonate() {
  const { profile } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  console.log("check check profile", profile);
  const location = useLocation();
  const navigateState = location.state || {};
  const state = useDonationState();
  const dispatch = useDonationDispatch();
  const query = useQuery();
  const [selectedId, setSelectedId] = useState("");
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pan, setPan] = useState("");
  const [address, setAddress] = useState("");
  const [inMemory, setInMemory] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState({ phone: "" });

  useEffect(() => {
    let mounted = true;
    loadRazorpaySDK().catch((e) => {
      if (mounted) console.warn("Razorpay preload failed:", e);
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const opt = query.get("opt");
    const amt = query.get("amt");
    if (opt) {
      setSelectedId(opt);
      const o = DONATION_OPTIONS.find((x) => x.id === opt);
      setAmount(o?.amount ?? amt ?? "");
      try {
        dispatch({
          type: "SET_SELECTION",
          payload: { id: opt, amount: o?.amount ?? (amt ? Number(amt) : null) },
        });
      } catch (e) {}
    } else if (state?.selectedOptionId) {
      setSelectedId(state.selectedOptionId);
      setAmount(state.amount ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onSelectChange(e) {
    const id = e.target.value;
    setSelectedId(id);
    const o = DONATION_OPTIONS.find((x) => x.id === id);
    setAmount(o?.amount ?? "");
    try {
      dispatch({
        type: "SET_SELECTION",
        payload: { id, amount: o?.amount ?? null },
      });
    } catch (e) {}
  }

  function onAmountChange(e) {
    console.log("check check 1", profile);
    const val = e.target.value.replace(/[^\d]/g, "");

    setAmount(val);
    try {
      dispatch({ type: "SET_AMOUNT", payload: Number(val) || null });
    } catch (e) {}
  }

  const storeFormData = async (paymentStatus, paymentDetails = {}) => {
    const selectedOption = DONATION_OPTIONS.find((x) => x.id === selectedId);
    const donationFor = selectedOption
      ? selectedOption.label
      : selectedId || "Quick Donation";

    const isSuccess =
      paymentStatus === "Payment Successful" || paymentStatus === "Success";

    const storingFormData = {
      PaymentStatus: isSuccess ? "Success" : "Failed",
      Name: name,
      Email: email,
      Number: phone,
      Festival: "Quick Donate",
      Seva: `${donationFor}`,
      Details: "-",
      Amount: amount,
      Date: new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      Address: address || "None",
      PANnumber: pan || "None",
    };

    const formBody = new URLSearchParams(storingFormData).toString();

    try {
      await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      });
      console.log("Quick Donate data stored in Google Sheets successfully");
      return true;
    } catch (error) {
      console.error("Error storing data in Google Sheets:", error);
      return false;
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (errors.phone) {
      alert("Please fix the errors before submitting the form");
      return;
    }
    if (!amount || Number(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }
    if (!name || !phone) {
      alert("Please enter your name and phone");
      return;
    }

    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    setProcessing(true);
    try {
      // 1. Create order on server
      const { data: order } = await axios.post(
        `${API}/api/payment/create-order`,
        { amount: Number(amount), currency: "INR" },
      );

      if (!order || !order.id) {
        throw new Error("Could not create Razorpay order.");
      }

      const selectedOption = DONATION_OPTIONS.find((x) => x.id === selectedId);
      const donationFor = selectedOption
        ? selectedOption.label
        : selectedId || "Quick Donation";

      // 2. Razorpay checkout options
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency || "INR",
        name: "ISKCON Vijayawada",
        description: `Donation - ${donationFor}`,
        order_id: order.id,
        handler: async (response) => {
          try {
            const verifyRes = await axios.post(
              `${API}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: Number(amount),
                  schemeName: donationFor,
                  donorName: name,
                  donorEmail: email,
                  donorPhone: phone,
                  donorPAN: pan,
                  donorAddress: address,
                },
              },
            );

            console.log("verifyRes:", verifyRes);

            if (verifyRes.data.success) {
              // 1. Store in Google Sheet
              await storeFormData("Payment Successful", response);

              // 2. Record donation in backend database
              try {
                const body = {
                  oper: "CREATEDON",
                  icsid: user?.icsid || "",
                  amount: amount,
                  schemeName: selectedId,
                  modeName: "online",
                  instrumentNo: response?.razorpay_payment_id,
                  instrumentDate: moment().format("DD-MM-YYYY"),
                  bankName: "Razorpay",
                  bankBranch: "web",
                  donorName: name,
                  donorEmail: email,
                  donorContact: phone,
                  donorPAN: pan,
                  donorCity: "",
                  donorState: "",
                  donorCountry: "",
                  donorAddress: address,
                  donorPin: "",
                };
              } catch (apiErr) {
                console.warn("Backend donation API warning:", apiErr);
              }

              alert("Payment Successful! Thank you for your donation.");

              // Reset form fields
              setAmount("");
              setName("");
              setEmail("");
              setPhone("");
              setPan("");
              setAddress("");
              setInMemory(false);
            } else {
              await storeFormData("Payment Failed", response);
              alert("Payment verification failed!");
            }
          } catch (err) {
            console.error("Payment verification error:", err);
            await storeFormData("Payment Failed", response);
            alert("Payment verification failed!");
          } finally {
            setProcessing(false);
          }
        },

        prefill: {
          name: name || profile?.name || "",
          email: email || profile?.email || "",
          contact: phone || profile?.phone || "",
        },

        notes: {
          donorName: name,
          donorEmail: email,
          donorPhone: phone,
          schemeName: donationFor,
          pan: pan,
          address: address,
        },

        modal: {
          ondismiss: function () {
            setProcessing(false);
          },
        },

        theme: {
          color: "#C61D21",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", async function (response) {
        setProcessing(false);
        alert(
          "Payment Failed: " +
            (response?.error?.description || "Transaction failed"),
        );
        await storeFormData("Payment Failed", response?.error?.metadata || {});
      });
      rzp.open();
    } catch (err) {
      console.error("Payment error:", err);
      setProcessing(false);
      alert(
        err.response?.data?.error ||
          err.message ||
          "Failed to initiate payment. Please try again.",
      );
    }
  }

  return (
    <>
      <Header />
      <div className={style.container}>
        <h2 className={style.heading}>
          {navigateState && navigateState?.component == "donateMore"
            ? "DONATE MORE"
            : "QUICK DONATE"}
        </h2>

        <p className={style.subText}>
          If you would like to make a donation towards a particular area of
          activity, please select an option from below. ISKCON relies entirely
          on voluntary donations and so every donation counts. Please note that
          donation is processed on a secure site.
        </p>

        <div className={style.separator} />

        <div className={style.grid}>
          {/* Left Column */}
          <div className={style.leftCol}>
            <div className={style.imageBox}>
              {/* Replace path if you have a specific image; keep require for bundlers */}
              <img src={FoorForLife} alt="Donation" className={style.image} />
            </div>

            <div className={style.note}>
              <strong>Please Note:</strong> Complete Address with PIN-Code and
              PAN is mandatory for an 80G Receipt.
            </div>
          </div>

          {/* Right Column - Form */}
          <div className={style.rightCol}>
            <form onSubmit={handleSubmit} className={style.formGrid}>
              <div>
                <label className={style.label}>Donation For</label>
                <select
                  className={style.select}
                  value={selectedId}
                  onChange={onSelectChange}
                >
                  <option value="">Select</option>
                  {DONATION_OPTIONS.map((o) => (
                    <option key={o.id} value={o.id}>
                      {o.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className={style.label}>Amount</label>
                <input
                  className={style.input}
                  value={amount}
                  onChange={onAmountChange}
                  placeholder="Amount"
                />
              </div>

              <div>
                <label className={style.label}>Mobile Number</label>
                <input
                  className={style.input}
                  value={phone}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/[^\d]/g, "");
                    if (cleaned.length > 10) {
                      setErrors((prev) => ({
                        ...prev,
                        phone: "Please enter a valid 10-digit phone number",
                      }));
                    } else {
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    }
                    setPhone(cleaned);
                  }}
                  placeholder="Phone Number"
                />
                {errors.phone && (
                  <p className={style.errorLabel}>{errors.phone}</p>
                )}
              </div>

              <div>
                <label className={style.label}>Email</label>
                <input
                  className={style.input}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                />
              </div>

              <div>
                <label className={style.label}>Name</label>
                <input
                  className={style.input}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                />
              </div>

              <div>
                <label className={style.label}>PAN (Optional)</label>
                <input
                  className={style.input}
                  value={pan}
                  onChange={(e) => setPan(e.target.value)}
                  placeholder="PAN"
                />
              </div>

              <div className={style.fullRow}>
                <label className={style.label}>Address (Optional)</label>
                <textarea
                  className={style.textarea}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Address with PIN Code"
                ></textarea>
              </div>

              <div className={style.fullRow}>
                <label className={style.checkboxLabel}>
                  <input
                    type="checkbox"
                    className={style.checkbox}
                    checked={inMemory}
                    onChange={(e) => setInMemory(e.target.checked)}
                  />{" "}
                  This Donation is in the memory/honor of someone or performed
                  on a specific occasion
                </label>
              </div>

              <div className={style.fullRow}>
                <button
                  className={style.primaryBtn}
                  type="submit"
                  disabled={processing}
                >
                  {processing ? "Processing..." : `Donate ₹${amount || 0}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
